export function createProductPath (sku: string, slug: string): string {
  return `/p/${sku}${slug.replace('/p/', '/')}`
}
